import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const ModalContainer = styled.div`
  @media (max-width: 480px) {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  @media (max-width: 480px) {
    width: 100vw;
    margin: 0;
  }
`;

export const TilePreviewBlock = styled.div`
  padding: 0;
`;

export const TileViewer = styled.div`
  @media (max-width: 480px) {
    width: 100% !important;
    padding-left: 8px;
    padding-right: 8px;
  }
`;

export const TileContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 0 82px;
`;

export const TilePreview = styled.div`
  width: 600px;
`;

export const QuizHeader = styled.div`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${themeGet('colors.black.100')};
  padding: 24px 24px 16px 24px;
`;

export const Divider = styled.hr`
  margin: 0px;
  background-color: ${themeGet('colors.black.20')};
  height: 0.5px;
`;

export const TileContent = styled.div`
  margin: 0;
  width: 100%;
  outline: 0;
  display: block;
  padding: 0px 24px;
  overflow-wrap: anywhere;
  overflow: hidden;
  a {
    color: ${themeGet('colors.primary.100')};
  }
  p {
    font-family: Montserrat, sans-serif;
    line-height: 24px;
    margin-bottom: 16px;
    margin-top: 0px;
    font-size: 16px;
    color: ${themeGet('colors.black.100')};
    letter-spacing: 0.1px;
  }
  ul {
    line-height: 24px;
    list-style-type: disc;
    padding-left: 24px;
  }
  ol {
    line-height: 24px;
    list-style-type: decimal;
    padding-left: 24px;
  }
  li {
    margin-bottom: 0.7em;
    line-height: 1.4;
  }
`;

export const ShareLink = styled.div`
  margin: auto;
  width: 100%;
  background: white;
  padding: 10px;
  text-align: left;
  padding: 16px 0px 8px 24px;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: ${themeGet('colors.black.80')};
  border-radius: 8px;
`;

export const ShareComponent = styled.div`
  max-width: 600px;
  margin-top: 24px;
  background: white;
  border: 1px solid ${themeGet('colors.black.20')};
  border-radius: 8px;
  padding: 0px;
  box-shadow: none;
  @media (max-width: 480px) {
    margin-bottom: 100px;
  }
`;

export const RoundedTileHolder = styled.div`
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08) !important;
  border-radius: 8px !important;
  margin-top: 0px;
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-radius: 8px;
  border: solid 1px ${themeGet('colors.black.20')};
  align-items: center;
  padding-left: 16px;
  font-family: Montserrat, sans-serif;
  font-style: normal;
`;

export const CopyLink = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: 0.2px;
  color: ${themeGet('colors.primary.100')};
  cursor: pointer;
  padding-right: 16px;
`;

export const ShareInput = styled.input`
  border-radius: 0 !important;
  border-width: 0 !important;
  margin-bottom: 0 !important;
  padding: 11px 0px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 18px;
  letter-spacing: 0.1px;
  color: ${themeGet('colors.black.100')};
`;

export const PreviewHeadline = styled.h2`
  margin: 0;
  color: ${themeGet('colors.black.100')};
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.8em;
  line-height: 1.5em;
  padding: 24px 24px 16px 24px;
`;

export const EarneblePoints = styled.div`
  background: ${themeGet('colors.peach')};
  color: white;
  display: inline-block;
  height: 50px;
  width: 123px;
  overflow: hidden;
  position: absolute;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  text-align: center;
  vertical-align: middle;
  padding-top: 16px;
`;

export const PointsText = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.1px;
`;

export const HeaderText = styled.span`
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.2px;
  color: ${themeGet('colors.primary.100')};
  margin-left: 3px;
`;

export const Header = styled.ul`
  width: 100%;
  max-width: 600px;
  display: flex;
  background: white;
  border-radius: 4px;
  margin: auto;
  border: 1px solid ${themeGet('colors.primary.100')};
  border-radius: 8px;
  @media (max-width: 480px) {
    margin-top: 40px;
  }
`;

export const PointsBar = styled.div`
  background: white;
  box-shadow: none;
  margin: 0px 24px;
  border: 1px solid ${themeGet('colors.black.10')};
  border-width: 1px 0px 1px 0px;
  height: 52px;
  vertical-align: middle;
`;

export const TileButton = styled.button`
  font-weight: 400;
`;

export const FullImage = styled.div`
  text-align: center;
  position: relative;
  &:after {
    @include clear;
  }

  &.loading {
    background-color: $off-white;
    border-bottom: 1px solid $secondary-gray;
    min-height: 400px;

    &:before {
      content: '\f1c5';
      font: var(--fa-font-solid);
      text-decoration: inherit;
      position: absolute;
      font-size: 70px;
      color: #a2a3a4;
      top: 40%;
      left: 0;
      margin: auto;
      z-index: 1;
      width: 100%;
    }
    .shadow_overlay,
    .tile_image {
      opacity: 0;
    }
  }
`;

export const DisclaimerText = styled.div`
  padding: 16px 0;
`;

export const AttachmentsWrapper = styled.div`
  padding: 0 24px;
`;

export const ProgressBarWrapper = styled.div`
  position: fixed;
  display: flex;
  width: 100%;
  bottom: 0;
  height: 70px;
  background: white;
  z-index: 1;
  box-shadow: 4px 0px 8px rgba(37, 40, 43, 0.14);
  ${themeGet('mediaQueries.forMediumUp')} {
    margin: 24px auto;
    position: relative;
    background: transparent;
    z-index: initial;
    box-shadow: none;
  }
`;
